import { ApolloClient, ApolloLink } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';

import { isStorybook } from 'utils/storybookUtils';

import {
  authLink,
  createPersistedQueryLinkIfEnabled,
  createSplitLink,
  errorLink,
  filterFieldsLink,
  operationTypeLink,
  scalarLink,
  uploadLink,
  wsLink,
} from './links';
import possibleTypes from './possibleTypes';
import { typePolicies } from './typePolicies';

export { subscriptionClient, wsLink } from './links';

const splitLink = createSplitLink(wsLink, uploadLink);

export const client = new ApolloClient({
  cache: new InMemoryCache({
    possibleTypes,
    typePolicies,
  }),
  dataMasking: false,
  defaultOptions: isStorybook()
    ? {
        query: { fetchPolicy: 'no-cache' },
        watchQuery: { fetchPolicy: 'no-cache' },
      }
    : undefined,
  devtools: {
    enabled: process.env.REACT_APP_APOLLO_DEV_TOOLS_ENABLED === 'true',
  },
  link: ApolloLink.from(
    [
      authLink(),
      createPersistedQueryLinkIfEnabled(),
      scalarLink,
      filterFieldsLink,
      errorLink,
      operationTypeLink,
      splitLink,
    ].filter(Boolean)
  ),
});
